import request from '@/utils/axios'

export function checkMobile(params) {
  return request({
    url: '/edu_home/check_mobile',
    method: 'get',
    params
  })
}

export function updateUserPassword(params) {
  return request({
    url: '/edu_home/update_user_password',
    method: 'post',
    data: params
  })
}

export function updateUserMobile(params) {
  return request({
    url: '/edu_home/auth/update_user_mobile',
    method: 'post',
    data: params
  })
}

export function getVerificationCode(params) {
  return request({
    url: '/edu_home/get_verification_code',
    method: 'get',
    params
  })
}

export function checkVerificationCode(params) {
  return request({
    url: '/edu_home/check_verification_code',
    method: 'get',
    params
  })
}
